import { schema } from 'normalizr';
import episode from 'schemas/episode';

const season = new schema.Entity('season', {
  episode_list: [episode],
});

export default season;
